import { render, staticRenderFns } from "./AdminCockpitCard.vue?vue&type=template&id=7e3396b0&scoped=true&"
import script from "./AdminCockpitCard.vue?vue&type=script&lang=ts&"
export * from "./AdminCockpitCard.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCockpitCard.vue?vue&type=style&index=0&id=7e3396b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3396b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VHover,VIcon})
